<script setup>
import { watch } from "vue";
import useHelpers from "@/Composables/UseHelpers";
const {$t} = useHelpers();

const emit = defineEmits([
    'update:postage_zone',
    'update:postage_amount',
]);

const props = defineProps({
  mandate_enabled: {
    required: false,
    default: false,
  },
  postage_enabled: {
    required: false,
    default: false,
  },
  postage_zones: {
    required: false,
    default: () => [],
  },
  postage_zone: {
    required: false,
    default: null,
  },
  qty: {
    required: false,
    default: 1,
  },
  errors: {
    required: true,
  }
});

function calculateFormula(formula, qty) {
  try {
    const expr = String(formula).replace(/\[qty\]/gi, qty);
    // Only allow numbers, operators, dots, spaces
    if (!/^[\d\s\.\+\-\*\/\(\)]+$/.test(expr)) return parseFloat(formula) || 0;
    return Function('"use strict"; return (' + expr + ')')();
  } catch (e) {
    return parseFloat(formula) || 0;
  }
}

function getZoneAmount(zone) {
  if (!zone || zone.amount == null) return 0;
  return calculateFormula(zone.amount, props.qty);
}

function selectZone(index) {
  const zone = props.postage_zones[index];
  const amount = getZoneAmount(zone);
  emit('update:postage_zone', zone.name);
  emit('update:postage_amount', amount);
}

// Recalculate postage_amount when qty changes
watch(() => props.qty, () => {
  if (props.postage_zone && props.postage_zones) {
    const zone = props.postage_zones.find(z => z.name === props.postage_zone);
    if (zone) emit('update:postage_amount', getZoneAmount(zone));
  }
});
</script>

<template>
  <div v-if="postage_enabled && postage_zones && postage_zones.length && !mandate_enabled">
    <hr class="mt-4 mb-4">
    <div class="form-group row mb-2">
    <label class="col-4 col-form-label">
      {{ $t('donation-form.postage') || 'Postage' }}
      <span class="text-red"> *</span>
    </label>
    <div class="col-8">
      <div
        :class="{ 'is-invalid': errors.postage_zone }"
      >
        <div
          v-for="(zone, index) in postage_zones"
          :key="index"
          class="form-check mb-1"
        >
          <input
            type="radio"
            class="form-check-input"
            :id="'postage_zone_' + index"
            name="postage_zone"
            :value="zone.name"
            :checked="postage_zone === zone.name"
            @change="selectZone(index)"
          >
          <label class="form-check-label" :for="'postage_zone_' + index">
            {{ zone.name }} — {{ vueNumberFormat(getZoneAmount(zone)) }}
          </label>
        </div>
      </div>

      <!-- Error message -->
      <div class="invalid-feedback" v-if="errors.postage_zone" style="display: block;">
        {{ errors.postage_zone }}
      </div>
    </div>
    </div>
  </div>
</template>
